'use client';

import Image from "next/image";
import { Check } from "lucide-react";

type StaticItem = {
  icon?: string;
  title?: string;
  benefits: string[];
};

type ItemsSectionProps = {
  items: StaticItem[];
};

export function ItemsSection({ items }: ItemsSectionProps) {
  return (
    <>
      {items.map((item, i) => (
        <div
          key={i}
          className="flex flex-col md:flex-row max-w-full items-start gap-6"
        >
          {item.icon && (
            <div className="w-[130px] h-[130px] bg-gray-50 rounded-xl flex items-center justify-center shrink-0">
              <Image
                src={item.icon}
                alt={item.title ?? "icon"}
                width={100}
                height={84}
                className="object-contain"
              />
            </div>
          )}

          <div className="flex flex-col gap-3">
            {item.title && (
              <h5 className="text-xl text-gray font-bold">{item.title}</h5>
            )}
            <div className="flex flex-col gap-2">
              {item.benefits.map((benefit, j) => (
                <div key={j} className="flex items-start gap-2 text-primary">
                  <Check className="text-primary-300 text-xl shrink-0" />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
